import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Button, Typography, IconButton, CircularProgress, Box, } from "@mui/material";
import HighlightAltIcon from "@mui/icons-material/HighlightAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
function cleanString(str) {
    return str.replace(/^(?:\.\.?\/?)/, "");
}
export function TreeNodeVisibilityButton({ onClick, name, active, isGroup, onMouseEnter, onMouseLeave, isHighlighted, notClickable, isSelection, groupIsExpanded, grouHandleClick, waitIcon, }) {
    return (_jsx(Button, Object.assign({ disableRipple: notClickable, size: "small", onClick: notClickable ? undefined : onClick, sx: {
            height: "26px",
            minWidth: 0,
            my: 0,
            width: "100%",
            cursor: notClickable ? "default" : "pointer",
            borderRadius: 1,
            transition: "background 0.5s, color 0.5s",
            backgroundColor: active ? "#d9d9d9" : "white",
            "& .MuiTypography-root": {
                color: active ? "rgba(0, 0, 0, 0.87)" : "rgba(0, 0, 0, 0.3)",
            },
            "& .MuiSvgIcon-root": {
                color: active ? "rgba(0, 0, 0, 0.87)" : "rgba(0, 0, 0, 0.3)",
            },
            "&:hover": {
                backgroundColor: active
                    ? "rgba(0, 0, 0, 0.12)"
                    : "rgba(0, 0, 0, 0.04)",
            },
        } }, { children: _jsxs(Box, Object.assign({ sx: {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
                spacing: 1,
                justifyContent: "flex-start",
                direction: "row",
            } }, { children: [isGroup ? (_jsx(IconButton, Object.assign({ "aria-label": "toggle-accordion", onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (grouHandleClick) {
                            grouHandleClick();
                        }
                    }, size: "small", sx: { color: "secondary.main", p: 0 } }, { children: groupIsExpanded === false ? (_jsx(ArrowRightIcon, { sx: { fontSize: "1.25rem", mb: "0.15rem" } })) : (_jsx(ArrowDropDownIcon, { sx: { fontSize: "1.25rem", mb: "0.15rem" } })) }))) : isSelection ? (_jsx(HighlightAltIcon, { sx: { fontSize: "1.25rem", mb: "0.15rem" } })) : null, _jsx(Typography, Object.assign({ noWrap: true, sx: {
                        height: "100%",
                        textTransform: "none",
                        textAlign: "left",
                        width: "100%",
                        whiteSpace: "nowrap",
                        fontWeight: isHighlighted ? "bold" : undefined,
                        fontSize: "0.75rem",
                        py: "1px",
                        overflow: "hidden",
                        display: "inline-block",
                        // marginBottom: "-8px",
                        direction: "rtl",
                        textOverflow: "ellipsis",
                        // position: "relative",
                        "&::-webkit-scrollbar": {
                            height: "6px",
                            // position: "absolute",
                            // top: "-5px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#bfbfbf",
                            "&:hover": {
                                backgroundColor: "#a6a6a6",
                            },
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "transparent",
                        },
                    } }, { children: name })), waitIcon && (_jsx(Box, Object.assign({ sx: { marginLeft: "auto", display: "flex" } }, { children: _jsx(CircularProgress, { size: 15, sx: { color: "#757575" } }) })))] })) })));
}
export default TreeNodeVisibilityButton;
